
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from "@/components/ui/button";

interface MobileMenuProps {
  navigation: Array<{ name: string; href: string }>;
  locationPages: Array<{ name: string; href: string }>;
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  navigation, 
  locationPages, 
  isMenuOpen, 
  setIsMenuOpen 
}) => {
  const location = useLocation();

  if (!isMenuOpen) return null;

  return (
    <nav className="md:hidden absolute z-50 top-full left-0 right-0 bg-background border-b border-border py-4 px-4 animate-fade-in">
      <div className="space-y-4">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={`block py-2 text-base font-medium transition-colors hover:text-piano-gold ${
              location.pathname === item.href
                ? 'text-piano-gold'
                : 'text-piano-black dark:text-white'
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            {item.name}
          </Link>
        ))}
        <Button asChild className="w-full bg-piano-gold hover:bg-piano-gold/90 text-white font-medium">
          <Link to="/kontakt" onClick={() => setIsMenuOpen(false)}>Gratis prøvetime</Link>
        </Button>
      </div>
    </nav>
  );
}

export default MobileMenu;
